<script>
export let name = 'compositor';
</script>

<h3 class="bg-gray-200
           text-xl text-blue-800
           mt-4 mb-2  px-2 py-1
           rounded-bl rounded-tl">{name}</h3>